/* eslint-disable lit/binding-positions */
import { classMap, Component, css, html, LitElement, property, styleMap, svg, TemplateResult } from '@rxdi/lit-html';
import { DirectiveResult } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';

export interface Tab {
  title?: string | DirectiveResult;
  link?: string;
  sub?: Tab[];
  active?: boolean;
  icon?: unknown;
  ruler?: boolean;
  border?: boolean;
}
/**
 * @customElement tabs-component
 */
@Component({
  selector: 'tabs-component',
  style: css`
    li.list-items {
      background-color: transparent;
      width: 100%;
      font-size: 13px;
      font-weight: bold;
      list-style: none;
      user-select: none;
    }

    li:hover a {
      color: black;
      /* background-color: var(--primary-bg-color); */

      background-color: var(--tabs-menu-hover-color, rgba(255, 255, 255, 1));
    }
    li a {
      padding: 14px 20px 13px 16px;
      line-height: 20px;
      height: 22px;
      text-decoration: none;
      display: block;
    }

    a.arrow {
      transform: rotate(180deg);
    }
    ul {
      margin: 0px;
      padding-left: 0px;
      border-bottom: 1px solid #e8e8e8;
      user-select: none;
    }

    li.list-items-inactive {
      background-color: #fff;

      color: #868f91;
      list-style: none;
    }
    li.list-items:hover {
      cursor: pointer;
      color: #868f91;
    }
    li.list-items-inactive:hover {
      color: black;
      cursor: pointer;
    }
    .active {
      color: black;
      cursor: pointer;
    }
    .flex {
      display: flex;
    }
    .spacer {
      flex: 1 3 auto;
    }
    .container {
      box-shadow: rgb(0 0 0 / 8%) 0px 14px 28px, rgb(0 0 0 / 8%) 0px 10px 10px;
    }

    .arrow-container {
      transition: transform 70ms cubic-bezier(0.2, 0, 0.38, 0.9) 0s,
        -webkit-transform 70ms cubic-bezier(0.2, 0, 0.38, 0.9) 0s;
    }
  `,
  template(this: TabsComponent) {
    return html`
      <div class="container" style=${styleMap({ background: this.bgColor })}>
        <!-- ${!this.menus.length
          ? html`
              <ul style="width: 10.5em;">
                <li class="list-items">
                  <div class="flex">
                    <a class="spacer"></a>
                    <div style="margin-top: 8px;">
                      <rx-spinner></rx-spinner>
                    </div>
                    <a class="spacer"></a>
                  </div>
                </li>
              </ul>
            `
          : html``} -->
        ${this.menus.map(
          (menu) => html`
            <span @click=${() => menu.link && this.router.go(menu.link)}>
              <ul @click=${() => this.toggleMenu(menu)}>
                <li class="list-items">
                  <div class="flex">
                    <div><a>${menu.title}</a></div>
                    <a class="spacer"></a>
                    <div>
                      ${menu.ruler
                        ? html`
                            <a
                              ><div
                                class="arrow-container"
                                style=${styleMap({
                                  transform: menu.active ? 'rotate(45deg)' : 'rotate(0deg)',
                                })}
                              >
                                ${svg`<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><!----><path d="M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"></path></svg>`}
                              </div></a
                            >
                          `
                        : ''}
                    </div>
                  </div>
                </li>
              </ul>

              ${menu.active
                ? html`
                    ${menu.sub
                      ? menu.sub
                          .filter((i) => !!i)
                          .map(
                            (subMenu) => html`
                              <ul>
                                <li
                                  @click=${() => subMenu.link && this.router.go(subMenu.link)}
                                  class=${classMap({
                                    'list-items-inactive': true,
                                    active: subMenu.active,
                                  })}
                                >
                                  <a style="font-size: 13px;"
                                    ><div style="display: flex">
                                      ${subMenu.icon ? subMenu.icon : html``}
                                      <div style="width:10px;">&nbsp;</div>
                                      <div>${subMenu.title}</div>
                                    </div></a
                                  >
                                </li>
                              </ul>
                            `
                          )
                      : ''}
                  `
                : ''}
            </span>
          `
        )}
      </div>
    `;
  },
})
export class TabsComponent extends LitElement {
  @Router() private router: Router;
  @property({ type: Array }) menus: Tab[] = [];

  @property({ type: String })
  bgColor = '#fff';

  private toggleMenu(menu: Tab) {
    menu.active = !menu.active;
    this.menus = [...this.menus];
  }
}
